import React from 'react';

// تم تحديث نوع 'Page' بإضافة نقطة الوصول الجديدة 'book-session' لتوسيع نطاق التحكم.
type Page = 'home' | 'robot-results' | 'session-results' | 'book-session' | 'try-robot';

interface NavProps {
  activePage: Page;
  setActivePage: (page: Page) => void;
}

const Nav: React.FC<NavProps> = ({ activePage, setActivePage }) => {
  // تم تعديل مصفوفة عناصر التنقل لإضافة نقطة السيطرة الجديدة 'حجز جلسة'.
  const navItems = [
    { id: 'home', label: 'الرئيسية' },
    { id: 'robot-results', label: 'نتائج الروبوت' },
    { id: 'session-results', label: 'نتائج الجلسات' },
    // إضافة نقطة السيطرة الجديدة
    { id: 'book-session', label: 'حجز جلسة' }, 
    { id: 'try-robot', label: 'تجربة الروبوت' },
  ];

  return (
    <nav className="my-8">
      <div className="max-w-xl mx-auto p-2 bg-[#0A1128]/70 backdrop-blur-md rounded-full border border-white/10 shadow-lg">
        <ul className="flex justify-around items-center">
          {navItems.map(item => (
            <li key={item.id} className="flex-1 text-center">
              <button
                onClick={() => setActivePage(item.id as Page)}
                className={`w-full px-3 py-2.5 text-xs md:text-sm font-bold rounded-full transition-all duration-300 transform focus:outline-none ${
                  activePage === item.id 
                    ? 'bg-[#22ff9b] text-[#060c1f] shadow-[0_0_15px_rgba(34,255,155,0.4)] scale-105' 
                    : 'text-gray-200 hover:bg-white/10'
                }`}
              >
                {item.label}
              </button>
            </li>
          ))}
        </ul>
      </div>
    </nav>
  );
};

export default Nav;